import React from "react";
import { HashRouter as Router, Routes, Route } from "react-router-dom";
import "./App.css";

import Navbar from "./components/Navbar";
import Footer from "./components/Footer";

import Home from "./pages/Home";
import Services from "./pages/Services";
import Portfolio from "./pages/Portfolio";
import Internship from "./pages/Internship";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Support from "./pages/Support";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import Cookies from "./pages/Cookies";
import Career from "./pages/Career";
import Terms from "./pages/Terms";
import Internshipform from "./pages/Internshipform";
import Scrollup from "./pages/Scrollup";
import Careerform from "./pages/Careerform";

/* Service Detail Pages */
import WebDevelopment from "./pages/WebDevelopment";
import MobileApp from "./pages/MobileApp";
import CloudSolutions from "./pages/CloudSolutions";
import ITSupport from "./pages/ITSupport";
import UIUX from "./pages/UIUX";
import DataAnalytics from "./pages/DataAnalytics";

function App() {
  return (
    <Router>
      <div className="App">
        <Scrollup />
        <Navbar />

        <main className="main-content">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/services" element={<Services />} />
            <Route path="/about" element={<About />} />
            <Route path="/portfolio" element={<Portfolio />} />
            <Route path="/internship" element={<Internship />} />
            <Route path="/career" element={<Career />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/support" element={<Support />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/cookies" element={<Cookies />} />
            <Route path="/internshipform" element={<Internshipform />} />
            <Route path="/careerform" element={<Careerform />} />



            {/* Service Pages */}
            <Route path="/web-development" element={<WebDevelopment />} />
            <Route path="/mobile-app" element={<MobileApp />} />
            <Route path="/cloud-solutions" element={<CloudSolutions />} />
            <Route path="/it-support" element={<ITSupport />} />
            <Route path="/ui-ux" element={<UIUX />} />
            <Route path="/data-analytics" element={<DataAnalytics />} />

            <Route path="*" element={<Home />} />
          </Routes>
        </main>

        <Footer />
      </div>
    </Router>
  );
}

export default App;
